export const tabList = [
  {
    name: 'instant',
    title: '立即派遣單',
  },
  {
    name: 'road',
    title: '路招單',
  },
  {
    name: 'reserveBefore',
    title: '預約單(前派)',
  },
  {
    name: 'reserveAfter',
    title: '預約單(後派)',
  },
  {
    name: 'airport',
    title: '機場預約',
  },
]



// WEBPACK FOOTER //
// ./src/constants/transaction.js